import React, { useEffect, useMemo, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Card, CardBody, CardHeader, Col, Row } from 'reactstrap';
import moment from "moment";
import TableContainer from '../../Components/Common/TableContainer';
import { listOrder } from '../Orders/_requests';
import { formatDate } from '../../helpers/FunctionHelpers';
const RecentOrders = () => {
  const [orderList, setOrderList] = useState<any>([]);

  const location = useLocation();

  useEffect(() => {
    listOrder().then((res: any) => {
      setOrderList(res.data);
    });
  }, [location.pathname]);
  const user = JSON.parse(localStorage.getItem("authUser") || "{}");
  console.log("Dashboard user: authUser", user);

  // Column
  const columns = useMemo(
    () => [
      {
        header: "S.No",
        id: "serial",
        enableSorting: false,
        enableColumnFilter: false,
        cell: (cell: any) => {
          const { pageIndex, pageSize } = cell.table.getState().pagination;
          const serialNumber = pageIndex * pageSize + cell.row.index + 1;
          return <span>{serialNumber}</span>;
        },
      },
      {
        header: "Order",
        accessorKey: "order_code_id",
        enableColumnFilter: false,
        cell: (cell: any) => {
          const row = cell.row.original;
          const date = row.order_date;
          const type = row.type;

          let label = "";
          let labelClass = "";

          if (type === 1) {
            label = "Order";
            labelClass = "badge bg-primary-subtle text-primary ms-2";
          } else if (type === 2) {
            label = "Subscription";
            labelClass = "badge bg-success-subtle text-success ms-2";
          }

          const isFirstOrder = row.is_first_order || row.user?.is_trial_used === 0 || row.user?.is_trial_used === false;

          return (
            <>
              <Link to={`/orders/view/${row.id}`} className="custom-redirect-link">
                {cell.getValue()}
                {label && <span className={labelClass}>{label}</span>}
                {isFirstOrder && <span className="badge bg-danger text-white ms-1">NEW</span>}
              </Link>
              <div>
                {formatDate(date)},
                
              </div>
            </>
          );
        },
      },


      {
        header: "User",
        accessorKey: "user.name",
        enableColumnFilter: false,
        cell: ({ row }: { row: { original: any } }) => {
          const userName = row.original.user?.name || "_";
          const mobile = row.original.user?.mobile_number;
          const altMobile = row.original.alternate_contact_number;
          return (
            <div>
              <strong>{userName}</strong>
              {mobile && <div className="text-muted small">{mobile}</div>}
              {altMobile && <div className="text-primary small fw-semibold">Alt: {altMobile}</div>}
            </div>
          );
        },
      },

     {
  header: "Amount",
  accessorKey: "total_amount",
  enableColumnFilter: false,
  cell: (cell: any) => {
    const amount = cell.getValue();
    return (
      <div style={{ textAlign: "right" }}>
        ₹{amount.toLocaleString("en-IN", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}
      </div>
    );
  },
},
,
      {
        header: "Route",
        accessorKey: "route.name",
        enableColumnFilter: false,
        cell: ({ row }: any) => row.original.route?.name || "_",

      },


      {
        header: "Store",
        accessorKey: "store.name",
        enableColumnFilter: false,
        cell: ({ row }: any) => {
          const storeName = row.original.store?.name || "_";
          const storeAddress = row.original.store?.address || "_";

          return (
            <div>
              <strong>{storeName}</strong>
              <br />
              <span className="text-muted">{storeAddress}</span>
            </div>
          );
        },
      },


      {
        header: "Address",
        accessorKey: "shipping_address",
        enableColumnFilter: false,
      },
      {
        header: "Status",
        accessorKey: "orderStatus.id",
        enableColumnFilter: false,
        cell: ({ row }: { row: { original: any } }) => {
          const { id: statusId, name: statusName } = row.original.orderStatus || {};
          const orderId = row.original.id;

          const statusMap: Record<number, { text: string; class: string }> = {
            1: { text: statusName, class: "bg-warning-subtle text-warning" },
            2: { text: statusName, class: "bg-secondary-subtle text-secondary" },
            3: { text: statusName, class: "bg-danger-subtle text-danger" },
            5: { text: statusName, class: "bg-primary-subtle text-primary" },
            6: { text: statusName, class: "bg-info-subtle text-info" },
            7: { text: statusName, class: "bg-success-subtle text-success" },
            8: { text: statusName, class: "bg-dark-subtle text-dark" },
            9: { text: statusName, class: "bg-light-subtle text-dark" },
          };

          const status = statusMap[statusId] || {
            text: statusName || "Nill",
            class: "bg-warning-subtle text-warning",
          };

          return (
            <div className="d-flex align-items-center gap-2">
              <span
                className={`badge fw-bold fs-7 ${status.class}`}
              //  onClick={() => toggleModal(orderId)}
              >
                {status.text}
              </span>
              {/* <Pencil size={14} className="text-muted cursor-pointer" onClick={() => toggleModal(orderId)} /> */}
            </div>
          );
        },
      },

    ],
    []
  );



  return (
    <React.Fragment>
      <Card>
        <CardHeader className="card-header border-0">
          <Row className="align-items-center gy-3">
            <div className="col-sm">
              <h5 className="card-title mb-0">Recent Orders</h5>
            </div>
          </Row>
        </CardHeader>
        <CardBody>
          <div>
            {orderList?.length ? (
              <TableContainer
                columns={columns}
                data={orderList || []}
                customPageSize={10}
                divClass="table-responsive table-card mb-1 mt-0"
                tableClass="align-top table-bordered align-top table-nowrap"
                theadClass="table-light text-muted text-uppercase"
              />
            ) : (
              <p className="fw-bold text-center">No Results Found</p>
            )}
          </div>
        </CardBody>
      </Card>

    </React.Fragment>
  );
};

export default RecentOrders;